import { GET_CHALLENGES, ACCEPT_CHALLENGE } from '../actionTypes/ChallengesActionTypes';

export const getChallenges = () => ({
    type: GET_CHALLENGES,
});

export const acceptChallenge = (offerId) => ({
    type: ACCEPT_CHALLENGE,
    payload: { offerId },
});
